module.exports = __webpack_public_path__ + "img/model_ug_67.c3fdb671.png";